import script from "./ShareBetBetslip.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareBetBetslip.vue?vue&type=script&setup=true&lang=js"

import "./ShareBetBetslip.vue?vue&type=style&index=0&id=0d8acbe8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8acbe8"]])

export default __exports__